import { Grid, Cell } from 'react-mdl'
import TimeAndTravel from '../../shared/questions/response_inputs/TimeAndTravel'

const { MdlSelect } = window

const DetailQuestionFields = ({
  allowResultEntry,
  detail,
  detailIndex,
  locale,
  values,
  onDetailChange,
  activityStartDate,
}) => {
  const handleValueChange = (field, value) => {
    if (onDetailChange && detail.id) {
      onDetailChange(detail.id, field, value)
    }
  }

  const handleTimeAndTravelChange = (timeAndTravelData) => {
    handleValueChange('value', timeAndTravelData)
  }

  const onCheckboxChange = (e) => {
    const value = e.target.value
    let checkboxArray = [...(values.checkboxValues || [])]
    const index = checkboxArray.indexOf(value)

    if (index >= 0) {
      checkboxArray.splice(index, 1)
    } else {
      checkboxArray.push(value)
    }

    const joinedValue = checkboxArray.join(';;')

    // Update both checkboxValues and value
    handleValueChange('checkboxValues', checkboxArray)
    handleValueChange('value', joinedValue)
  }

  const renderInputByType = () => {
    switch (detail.report_detail_question.input_type) {
      case 'text':
        return (
          <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label textfield__input--full">
            <input
              className="mdl-textfield__input"
              type="text"
              name={`program_event_instructor[instructor_result_details_attributes][${detailIndex}][value]`}
              id={`program_event_instructor_instructor_result_details_attributes_${detailIndex}_value`}
              value={values.value}
              onChange={(e) => handleValueChange('value', e.target.value)}
              disabled={!allowResultEntry}
              required={detail.report_detail_question.required}
            />
            <label
              className={`mdl-textfield__label string ${
                detail.report_detail_question.required ? 'required' : ''
              } control-label`}
              htmlFor={`question-${detailIndex}-detail-${detail.report_detail_question.id}`}>
              {detail.report_detail_question.question}
              {detail.report_detail_question.required && <span aria-hidden="true"> *</span>}
            </label>
            {!!detail.report_detail_question.description && (
              <small
                dangerouslySetInnerHTML={{ __html: detail.report_detail_question.description }}
              />
            )}
          </div>
        )

      case 'number':
        return (
          <div
            className={`mdl-textfield mdl-js-textfield mdl-textfield--floating-label textfield__input--full integer ${
              detail.report_detail_question.required ? 'required' : ''
            }`}>
            <input
              className="mdl-textfield__input numeric integer"
              type="number"
              name={`program_event_instructor[instructor_result_details_attributes][${detailIndex}][value]`}
              id={`program_event_instructor_instructor_result_details_attributes_${detailIndex}_value`}
              value={values.value}
              onChange={(e) => handleValueChange('value', e.target.value)}
              disabled={!allowResultEntry}
              required={detail.report_detail_question.required}
            />
            <label
              className={`mdl-textfield__label integer ${
                detail.report_detail_question.required ? 'required' : ''
              } control-label`}
              htmlFor={`question-${detailIndex}-detail-${detail.report_detail_question.id}`}>
              {detail.report_detail_question.question}
              {detail.report_detail_question.required && <span aria-hidden="true"> *</span>}
            </label>
            {!!detail.report_detail_question.description && (
              <small
                dangerouslySetInnerHTML={{ __html: detail.report_detail_question.description }}
              />
            )}
          </div>
        )

      case 'date':
        return (
          <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label textfield__input--full">
            <input
              type="text"
              className="mdl-textfield__input date-input"
              data-mask={`date.${locale}`}
              name={`program_event_instructor[instructor_result_details_attributes][${detailIndex}][value]`}
              id={`program_event_instructor_instructor_result_details_attributes_${detailIndex}_value`}
              value={values.value}
              onChange={(e) => handleValueChange('value', e.target.value)}
              disabled={!allowResultEntry}
              required={detail.report_detail_question.required}
            />
            <label className="mdl-textfield__label">{detail.report_detail_question.question}</label>
            {!!detail.report_detail_question.description && (
              <small
                dangerouslySetInnerHTML={{ __html: detail.report_detail_question.description }}
              />
            )}
          </div>
        )

      case 'height':
        if (locale !== 'en_ca') {
          return (
            <Grid className="p-0">
              <Cell className="ml-0">
                <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label textfield__input--full">
                  <input
                    className="mdl-textfield__input"
                    type="number"
                    name={`program_event_instructor[instructor_result_details_attributes][${detailIndex}][height_feet]`}
                    id={`program_event_instructor_instructor_result_details_attributes_${detailIndex}_height_feet`}
                    value={values.height_feet}
                    required={detail.report_detail_question.required}
                    onChange={(e) => handleValueChange('height_feet', e.target.value)}
                    disabled={!allowResultEntry}
                  />
                  <label
                    className={`mdl-textfield__label string ${
                      detail.report_detail_question.required ? 'required' : ''
                    } control-label`}
                    htmlFor={`program_event_instructor_instructor_result_details_attributes_${detailIndex}_height_feet`}>
                    {`${detail.report_detail_question.question} (ft)`}
                    {detail.report_detail_question.required && <span aria-hidden="true"> *</span>}
                  </label>
                  {!!detail.report_detail_question.description && (
                    <small
                      dangerouslySetInnerHTML={{
                        __html: detail.report_detail_question.description,
                      }}
                    />
                  )}
                </div>
              </Cell>
              <Cell className="mr-0">
                <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label textfield__input--full">
                  <input
                    className="mdl-textfield__input"
                    type="number"
                    name={`program_event_instructor[instructor_result_details_attributes][${detailIndex}][height_inches]`}
                    id={`program_event_instructor_instructor_result_details_attributes_${detailIndex}_height_inches`}
                    value={values.height_inches}
                    required={detail.report_detail_question.required}
                    onChange={(e) => handleValueChange('height_inches', e.target.value)}
                    disabled={!allowResultEntry}
                  />
                  <label
                    className={`mdl-textfield__label string ${
                      detail.report_detail_question.required ? 'required' : ''
                    } control-label`}
                    htmlFor={`program_event_instructor_instructor_result_details_attributes_${detailIndex}_height_inches`}>
                    {`${detail.report_detail_question.question} (in)`}
                    {detail.report_detail_question.required && <span aria-hidden="true"> *</span>}
                  </label>
                </div>
              </Cell>
            </Grid>
          )
        } else {
          return (
            <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label textfield__input--full">
              <input
                className="mdl-textfield__input"
                type="number"
                name={`program_event_instructor[instructor_result_details_attributes][${detailIndex}][value]`}
                id={`program_event_instructor_instructor_result_details_attributes_${detailIndex}_value`}
                value={values.value}
                onChange={(e) => handleValueChange('value', e.target.value)}
                required={detail.report_detail_question.required}
                disabled={!allowResultEntry}
              />
              <label
                className={`mdl-textfield__label string ${
                  detail.report_detail_question.required ? 'required' : ''
                } control-label`}
                htmlFor={`question-${detailIndex}-detail-${detail.report_detail_question.id}`}>
                {`${detail.report_detail_question.question} (cm)`}
                {detail.report_detail_question.required && <span aria-hidden="true"> *</span>}
              </label>
              {!!detail.report_detail_question.description && (
                <small
                  dangerouslySetInnerHTML={{ __html: detail.report_detail_question.description }}
                />
              )}
            </div>
          )
        }

      case 'weight':
        return (
          <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label textfield__input--full">
            <input
              className="mdl-textfield__input"
              type="number"
              name={`program_event_instructor[instructor_result_details_attributes][${detailIndex}][value]`}
              id={`program_event_instructor_instructor_result_details_attributes_${detailIndex}_value`}
              value={values.weight}
              required={detail.report_detail_question.required}
              onChange={(e) => handleValueChange('weight', e.target.value)}
              disabled={!allowResultEntry}
            />
            <label
              className={`mdl-textfield__label string ${
                detail.report_detail_question.required ? 'required' : ''
              } control-label`}
              htmlFor={`question-${detailIndex}-detail-${detail.report_detail_question.id}`}>
              {`${detail.report_detail_question.question} (${locale !== 'en_ca' ? 'lbs' : 'kg'})`}
              {detail.report_detail_question.required && <span aria-hidden="true"> *</span>}
            </label>
            {!!detail.report_detail_question.description && (
              <small
                dangerouslySetInnerHTML={{ __html: detail.report_detail_question.description }}
              />
            )}
          </div>
        )

      case 'dropdown':
        return (
          <div>
            <MdlSelect
              id={`program_event_instructor_instructor_result_details_attributes_${detailIndex}_value`}
              name={`program_event_instructor[instructor_result_details_attributes][${detailIndex}][value]`}
              onOptionSelected={(value) => handleValueChange('value', value)}
              includeBlankOption={true}
              label={detail.report_detail_question.question}
              selected={values.value}
              disabled={!allowResultEntry}
              required={detail.report_detail_question.required}
              options={detail.report_detail_question.question_responses.map((response) => ({
                id: response.value,
                name: response.value,
              }))}
            />
            {!!detail.report_detail_question.description && (
              <small
                dangerouslySetInnerHTML={{ __html: detail.report_detail_question.description }}
              />
            )}
          </div>
        )

      case 'radio_buttons':
        return (
          <div className="block--full radio_buttons--stacked">
            <label className="text--small text--darkblue u-line-height--1 mt-0 mb-20">
              {detail.report_detail_question.question}
              {detail.report_detail_question.required && ' *'}
            </label>
            {!!detail.report_detail_question.description && (
              <small
                dangerouslySetInnerHTML={{ __html: detail.report_detail_question.description }}
              />
            )}
            {detail.report_detail_question.question_responses.map((response, responseIndex) => {
              const uniqueId = `radio-${detailIndex}-${detail.report_detail_question.id}-${responseIndex}`
              return (
                <div key={response.id} className="mdl-cell mdl-cell--12-col ml-0">
                  <label className="mdl-radio mdl-js-radio mdl-js-ripple-effect" htmlFor={uniqueId}>
                    <input
                      type="radio"
                      id={uniqueId}
                      disabled={!allowResultEntry}
                      name={`program_event_instructor[instructor_result_details_attributes][${detailIndex}][value]`}
                      className="mdl-radio__button"
                      value={response.value}
                      onChange={() => {
                        handleValueChange('value', response.value)
                      }}
                      checked={String(values.value || '') === String(response.value)}
                    />
                    {response.value}
                  </label>
                </div>
              )
            })}
          </div>
        )

      case 'checkboxes':
        return (
          <div className="block--full check_boxes--stacked">
            <label className="text--small text--darkblue u-line-height--1 mt-0 mb-20">
              {detail.report_detail_question.question}
              {detail.report_detail_question.required && ' *'}
            </label>
            {!!detail.report_detail_question.description && (
              <small
                dangerouslySetInnerHTML={{ __html: detail.report_detail_question.description }}
              />
            )}
            <br />
            {detail.report_detail_question.question_responses.map((response) => (
              <label
                key={response.id}
                className="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect boolean optional">
                <input
                  disabled={!allowResultEntry}
                  checked={(values.checkboxValues || []).includes(response.value)}
                  className="mdl-checkbox__input"
                  type="checkbox"
                  value={response.value}
                  onChange={onCheckboxChange}
                />
                <span className="mdl-checkbox__label">{response.value}</span>
              </label>
            ))}
            <input
              type="hidden"
              name={`program_event_instructor[instructor_result_details_attributes][${detailIndex}][value]`}
              value={values.value || ''}
            />
          </div>
        )

      case 'time_and_travel':
        return (
          <TimeAndTravel
            disabled={!allowResultEntry}
            name={`program_event_instructor[instructor_result_details_attributes][${detailIndex}]`}
            value={values.value}
            start_at={detail.start_at}
            end_at={detail.end_at}
            question={detail.report_detail_question}
            onChange={handleTimeAndTravelChange}
            activityStartDate={activityStartDate}
          />
        )

      case 'file_upload':
        return (
          <div
            className={`mdl-textfield mdl-js-textfield mdl-textfield--floating-label textfield__input--full integer ${
              detail.report_detail_question.required ? 'required' : ''
            }`}>
            <br />
            <label
              className={`mdl-textfield__label ${
                detail.report_detail_question.required ? 'required' : ''
              } control-label`}
              htmlFor={`question-${detailIndex}-detail-${detail.report_detail_question.id}`}>
              {detail.report_detail_question.question}
              {detail.report_detail_question.required && <span aria-hidden="true"> *</span>}
            </label>
            {!!detail.report_detail_question.description && (
              <small
                className="my-5"
                style={{ display: 'block' }}
                dangerouslySetInnerHTML={{ __html: detail.report_detail_question.description }}
              />
            )}
            <input
              disabled={!allowResultEntry}
              className=""
              name={`program_event_instructor[instructor_result_details_attributes][${detailIndex}][attachment]`}
              type="file"
            />
            {detail.attachment_url && (
              <div className="my-5">
                Uploaded on{' '}
                {new Date(detail.updated_at).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: '2-digit',
                  timeZoneName: 'short',
                })}
                <br />
                <ul>
                  <li>
                    <a
                      href={detail.attachment_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: 'none' }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-download"
                        viewBox="0 0 16 16">
                        <path d="M.5 9.9  a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                      </svg>
                      &nbsp;
                      {detail.attachment_filename || 'View uploaded file'}
                    </a>
                  </li>
                </ul>
              </div>
            )}
          </div>
        )

      default:
        return null
    }
  }

  return (
    <div className="mdl-grid block--full">
      <input
        name={`program_event_instructor[instructor_result_details_attributes][${detailIndex}][id]`}
        id={`program_event_instructor_instructor_result_details_attributes_${detailIndex}_id`}
        value={detail.id}
        type="hidden"
      />
      <input
        name={`program_event_instructor[instructor_result_details_attributes][${detailIndex}][report_detail_question_id]`}
        id={`program_event_instructor_instructor_result_details_attributes_${detailIndex}_report_detail_question_id`}
        value={detail.report_detail_question_id}
        type="hidden"
      />
      <div className="mdl-cell mdl-cell--12-col">{renderInputByType()}</div>
    </div>
  )
}

export default DetailQuestionFields
